import { Component, OnInit, ViewChild } from '@angular/core';
import { MmTableDirective } from '../paged-table.directive';

@Component({
  selector: 'mm-extension-management',
  templateUrl: './extension-management.component.html',
  styleUrls: ['./extension-management.component.scss']
})
export class ExtensionManagementComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    this.mmTable.search();
  }

  @ViewChild(MmTableDirective, { static: true })
  private mmTable: MmTableDirective<any, any>






}
